module.exports = __webpack_public_path__ + "img/croatia.23aa4c3f.png";